export default {
  REACT_APP_SERVER_URL: process.env.REACT_APP_SERVER_URL,
  FILE_IMAGE_URL: process.env.REACT_APP_IMAGE_URL,
  FILE_DOWNLOAD_URL: process.env.REACT_APP_PUBLIC_URL,
  REACT_APP_GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY,
};
